import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import "./main-article.scss";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { GatsbyImage } from "gatsby-plugin-image";
import { findRel } from "../../../shared/utils/stringUtilities";

const MainArticle = (props: ReferenciaContenido) => {
  const main = props.referenciaPlantillaContenido[0];
  const arrayPlantilla = [
    props.referenciaPlantillaContenido[1],
    props.referenciaPlantillaContenido[2],
    props.referenciaPlantillaContenido[3],
    props.referenciaPlantillaContenido[4],
  ];
  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };
  return (
    <div className="m-main-article">
      <div className="m-main-article-body">
        <GatsbyImage
          className="m-main-article-body-img"
          image={main.imagenPrincipal[0].gatsbyImageData}
          alt={main.imagenPrincipal[0].title || "Banner Noticias"}
        />
        <div className="m-main-article-body-content">
          <h1 className="m-main-article-body-content-title gtmRedDeAmorNecesitasConversarDinamico">
            {main.tituloBanner}
          </h1>
          <h2 className="m-main-article-body-content-secondary">
            {JSON.parse(main.descripcion.raw)?.content[0]?.content[0]?.value}
          </h2>
          <ul className="m-main-article-body-liltags">
            {main.redireccionTabs.map((val, key) => {
              return (
                <li
                  key={"mini" + key}
                  className={`gtmRedDeAmorNecesitasConversar${normalizeTwoWords(
                    val.nombreTab
                  )}`}
                >
                  <a
                    className={`gtmRedDeAmorNecesitasConversar${normalizeTwoWords(
                      val.nombreTab
                    )}`}
                    href={val.redireccionTab}
                    target={isHttp(val.redireccionTab) ? "_blank" : "_self"}
                    rel={findRel(val.redireccionTab)}
                  >
                    {val.nombreTab}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <div>
        <h2 className="m-main-article-list-subtitle title-secondary">
          Artículos recientes
        </h2>
        {arrayPlantilla.map((val, i) => {
          return (
            <a
              href={val.redireccionBoton}
              key={"min" + i}
              target={isHttp(val.redireccionBoton) ? "_blank" : "_self"}
              rel={findRel(val.redireccionBoton)}
              className={`gtmRedDeAmorContenido${normalizeTwoWords(
                val.tituloDescripcion
              )}`}
            >
              <div
                className={`m-main-article-list  gtmRedDeAmorContenido${normalizeTwoWords(
                  val.tituloDescripcion
                )}`}
              >
                <div
                  className={`m-main-article-list-img  gtmRedDeAmorContenido${normalizeTwoWords(
                    val.tituloDescripcion
                  )}`}
                >
                  <GatsbyImage
                    src={val.imagenPrincipal[0].gatsbyImageData}
                    className={`show-on-mobile m-main-article-list-img  gtmRedDeAmorContenido${normalizeTwoWords(
                      val.tituloDescripcion
                    )}`}
                    alt={val.imagenPrincipal[0].title || "imagen lateral"}
                  />
                  <GatsbyImage
                    className={`hide-on-mobile  gtmRedDeAmorContenido${normalizeTwoWords(
                      val.tituloDescripcion
                    )}`}
                    image={val.imagenPrincipal[0].gatsbyImageData}
                    alt={val.imagenPrincipal[0].title || "imagen lateral"}
                  />
                </div>
                <div
                  className={`m-main-article-list-content  gtmRedDeAmorContenido${normalizeTwoWords(
                    val.tituloDescripcion
                  )}`}
                >
                  <h4
                    className={`m-main-article-list-content-title  gtmRedDeAmorContenido${normalizeTwoWords(
                      val.tituloDescripcion
                    )}`}
                  >
                    {val.tituloDescripcion}
                  </h4>
                  <p
                    className={`m-main-article-list-content-subtitle  gtmRedDeAmorContenido${normalizeTwoWords(
                      val.tituloDescripcion
                    )}`}
                  >
                    {val.tituloBanner}
                  </p>
                  <span
                    className={`m-main-article-list-content-date  gtmRedDeAmorContenido${normalizeTwoWords(
                      val.tituloDescripcion
                    )}`}
                  >
                    {val.descripcion
                      ? JSON.parse(val.descripcion.raw)?.content[0]?.content[0]
                          ?.value
                      : ""}
                  </span>
                </div>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default MainArticle;
